// Typed wrapper around /api/v1/admin/units. Powers the unit-picker on the
// invoice create form. Phase 5c will replace this with a full units browser.

import type {
  AdminUnit,
  CreateAdminUnitRequest,
  UpdateAdminUnitRequest,
} from '@livinhome/shared';
import { api } from './api-client';

export type { AdminUnit, CreateAdminUnitRequest, UpdateAdminUnitRequest };

export async function listAdminUnits(): Promise<AdminUnit[]> {
  const { data } = await api.get<{ units: AdminUnit[] }>('/admin/units');
  return data.units;
}

export async function createUnit(body: CreateAdminUnitRequest): Promise<AdminUnit> {
  const { data } = await api.post<{ unit: AdminUnit }>('/admin/units', body);
  return data.unit;
}

export async function updateUnit(
  id: string,
  body: UpdateAdminUnitRequest,
): Promise<AdminUnit> {
  const { data } = await api.patch<{ unit: AdminUnit }>(`/admin/units/${id}`, body);
  return data.unit;
}

export async function deleteUnit(id: string): Promise<void> {
  await api.delete(`/admin/units/${id}`);
}

/** "Block A / 12 (Mawar 12)" — display label combining block + number + label. */
export function formatUnitOption(u: AdminUnit): string {
  return `Block ${u.block} / ${u.number}${u.label && u.label !== u.number ? ` (${u.label})` : ''}`;
}
